import { render, staticRenderFns } from "./notify.vue?vue&type=template&id=1008603a&scoped=true"
import script from "./notify.vue?vue&type=script&lang=js"
export * from "./notify.vue?vue&type=script&lang=js"
import style0 from "./notify.vue?vue&type=style&index=0&id=1008603a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1008603a",
  null
  
)

export default component.exports